// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { neonDevnet as _neonDevnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the neonDevnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 245022926
 * Chain Name: Neon EVM DevNet
 * Default Block Explorer: https://devnet.neonscan.org
 * Default RPC URL: https://devnet.neonevm.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { neonDevnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: neonDevnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const neonDevnet = createCommon({
	..._neonDevnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
